var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSendFavRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSendFavRed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.0%",
    y: "-18.0%",
    width: "136.0%",
    height: "136.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627451   0 0 0 0 0.419607843   0 0 0 0 0.274509804  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.0008623,11.9700288 C32.4535803,11.5295322 32.6133902,10.8830414 32.4181182,10.2820716 C32.2223856,9.68110187 31.7125597,9.25210049 31.0862155,9.1610584 L25.5172779,8.35317477 C25.280096,8.31868913 25.0751525,8.17017097 24.9692266,7.95544037 L22.4795081,2.91777787 C22.1999559,2.35175354 21.6325617,2 21.0002303,2 C20.3683594,2 19.8009652,2.35175354 19.521413,2.91777787 L17.0312339,7.95590018 C16.925308,8.17063077 16.719904,8.31914894 16.4827221,8.35363458 L10.9137845,9.1615182 C10.2879008,9.25210049 9.77761443,9.68156168 9.58188184,10.2825315 C9.3866098,10.8835012 9.5464197,11.5299921 9.99913767,11.9704887 L14.0284657,15.891736 C14.2002499,16.0591063 14.2790034,16.300046 14.2384753,16.535468 L13.2879057,22.0724825 C13.2036256,22.5598796 13.3316577,23.0339422 13.6475931,23.4077666 C14.1385365,23.990344 14.995615,24.1678301 15.6809093,23.8082598 L20.6612675,21.1937884 C20.8694348,21.0848138 21.1314862,21.0857334 21.3391931,21.1937884 L26.3200118,23.8082598 C26.5622596,23.9356268 26.8206267,24 27.0872835,24 C27.574082,24 28.0355504,23.78389 28.3528674,23.4077666 C28.6692634,23.0339422 28.796835,22.55896 28.7125548,22.0724825 L27.7615247,16.535468 C27.7209966,16.2995862 27.7997501,16.0591063 27.9715343,15.891736 L32.0008623,11.9700288 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-JS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "RedHotPie-Premium+-upgrade",
    transform: "translate(-9.000000, -719.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 505.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icSendFavRed",
    transform: "translate(15.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(8.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F76B46",
    fillRule: "nonzero",
    transform: "translate(21.000000, 13.000000) rotate(10.000000) translate(-21.000000, -13.000000) ",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(5.500000, 16.000000) rotate(90.000000) translate(-5.500000, -16.000000) translate(1.000000, 11.000000)",
    stroke: "#F76B46",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,2 L0.5,8",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,2.84217094e-13 L4.5,10",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,2 L8.5,8",
    id: "Line"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSendFavRed);
export default __webpack_public_path__ + "static/media/icSendFavRed.a35d332d783a77db1729c1cdba08985e.svg";
export { ForwardRef as ReactComponent };